<ng-template #TankNotificationTooltip>
  <tank-notification-tooltip [id]="id" [tankNotifications]="tankNotifications">
  </tank-notification-tooltip>
</ng-template>
<div *ngIf="tankNotificationCount > 0"
    (click)="showTankNotifications(id)"
    class="tank-notifications"
    fxLayoutAlign="left"

    [tooltip]="TankNotificationTooltip"
    maxWidth="600px"

    contentType="template"
    tooltip-class="wide-tooltip"
    placement="bottom"
    padding-left="10px"
    content-type="template">
      <span matBadge="{{tankNotificationCount}}" matBadgeSize="small" matBadgeColor="accent">
      </span>
</div>




